import { Component, Input, ElementRef } from '@angular/core';

import { GasColor } from '../../../core/colors/color.namespace';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasStepsState, GasStepsType } from '../gas-steps.interface';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=113%3A0 */

const PRESETS = {
  [GasStepsState.Active]: {
    name: GasIcon.Common.StrokeBall,
    color: GasColor.Color.Brand,
    size: 14,
  },
  [GasStepsState.Warning]: {
    name: GasIcon.Notifications.Warning,
    color: GasColor.Color.Warning,
    size: 24,
  },
  [GasStepsState.Success]: {
    name: GasIcon.Notifications.Success,
    color: GasColor.Color.SuccessDark,
    size: 18,
  },
  [GasStepsState.Base]: {
    name: GasIcon.Common.Ball,
    color: GasColor.Color.Light,
    size: 10,
  },
};

@Component({
  selector: 'gas-step',
  templateUrl: 'gas-steps.component.html',
})
export class GasStepsComponent {
  /** текущее состояние шага */
  @Input()
  public set status(status: GasStepsType) {
    this.stepStatus = status;
    const actual = status || GasStepsState.Base;

    this.iconName = PRESETS[actual].name;
    this.iconColor = PRESETS[actual].color;
    this.iconSize = PRESETS[actual].size;

    if (this.stepStatus === GasStepsState.Success || this.stepStatus === GasStepsState.Warning) {
      this.successStep = true;
    }
  }

  public get status(): GasStepsType {
    return this.stepStatus;
  }

  /** Заголовок шага */
  @Input()
  public title: string;

  /** Дополнительная информация (можно использовать как сабтайтл) */
  @Input()
  public description: string;

  /** Иконка для кнопки (для вертикальных шагов) */
  @Input()
  public buttonIcon: GasIcon.Icons | string;

  /** Флаг, который оставляет содержимое контента расскрытым */
  @Input()
  public visibility = false;

  public viewNextButton = false;
  public iconName: string = GasIcon.Common.Ball;
  public iconColor: GasColor.Color = GasColor.Color.Light;
  public iconSize: number;
  public stepStatus: GasStepsType;
  public isViewContent = false;
  public successStep = false;

  constructor(
    public elementRef: ElementRef,
  ) {}

  public hideContent(): void {
    this.isViewContent  = false;
  }
}
